import React from 'react'

if (process.env.REACT_APP_COMPONENT_LANGUAGE_TOGGLE_LAYOUT === 'default') {
	require('../../../styles/css/components/language/bk-flow-language-toggle.css')
}

const BkFlowLanguageToggleDefault = props => {
		const {
			hotelLabels,
			currentLanguage,
			languageEvent,
			languageOptions
		} = props

		return (
			<div className="bk-flow__language">
				<div className="bk-flow__language-toggle">
					<label
						id="languageLabel"
						className="u-font-small u-font-bold"
						htmlFor="language"
					>
						{ hotelLabels.language ? hotelLabels.language : 'Language' }
					</label>

					<select
						className="u-form__select"
						name="language"
						onChange={ e => languageEvent( e.target.value )}
						value={ currentLanguage }
						tabIndex={ 0 }
						aria-labelledby="languageLabel"
					>
						{ languageOptions }
					</select>
				</div>
			</div>
		)
}


export default BkFlowLanguageToggleDefault


// WEBPACK FOOTER //
// ./src/components/language/layouts/BkFlowLanguageToggleDefault.js